import { motion } from "framer-motion";
export const Hero = () => {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8
  }} className="max-w-4xl mx-auto px-4 sm:px-6 py-20">
      {/* Breadcrumb */}
      

      {/* Main Headline */}
      <div className="space-y-8">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="font-sans font-normal tracking-tight text-3xl md:text-4xl lg:text-5xl text-foreground max-w-5xl">
          We started the independent, public dataset that parents deserve.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          className="text-base leading-relaxed text-foreground"
        >
          Email us at{" "}
          <a
            href="mailto:team@fixtheformula.org"
            className="text-primary hover:text-accent underline-offset-4 hover:underline"
          >
            team@fixtheformula.org
          </a>{" "}
          to test a specific formula, your breastmilk, or donate to the cause.
        </motion.p>
      </div>
    </motion.section>;
};